import React, { useEffect } from 'react'
import { useRoute } from '@react-navigation/core'
import { RouteProp } from '@react-navigation/native'
import { LoadingContainer } from '@screens/Common/containers/LoadingContainer.tsx'
import { useUpgradeSubscriptionProduct } from '@screens/Marketplace/utils/hooks.ts'
import { AppStackParamList } from '@navigation/types'
import { Bugsnag } from '@config'

export const PurchaseFreeByosProduct = () => {
  const upgradeSubscriptionProduct = useUpgradeSubscriptionProduct()
  const {
    params: { subscription, product },
  } = useRoute<RouteProp<AppStackParamList, 'PurchaseFreeByosProduct'>>()

  useEffect(() => {
    if (product.price > 0) {
      Bugsnag.notify(new Error(`PurchaseFreeByosProduct - product is not free`))
    }

    upgradeSubscriptionProduct(subscription.id, product)
  }, [product, subscription.id, upgradeSubscriptionProduct])

  return <LoadingContainer />
}
